var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"event"}},[_c('app-city-header',{attrs:{"payload":_vm.payload}}),_c('v-row',[_c('v-col',[_c('single-calendar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }